import api from './client';

/** Minimalne dane maszyny dla niezalogowanego zgłaszającego (po zeskanowaniu QR). */
export interface PublicMachineInfo {
  name: string;
  description: string | null;
  ticketSystemEnabled: boolean;
}

/** Wynik anonimowego zgłoszenia: nadany numer zgłoszenia. */
export interface PublicTicketResult {
  ticketNumber: number;
}

export const publicApi = {
  getMachineByQr: (qrSlug: string) =>
    api.get<PublicMachineInfo>(`/api/public/machines/by-qr/${qrSlug}`),

  createTicket: (
    qrSlug: string,
    data: { email: string; title: string; message: string; files?: File[] },
  ) => {
    const form = new FormData();
    form.append('email', data.email);
    form.append('title', data.title);
    form.append('message', data.message);
    (data.files ?? []).forEach((f) => form.append('files', f));
    return api.post<PublicTicketResult>(
      `/api/public/machines/by-qr/${qrSlug}/tickets`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  },
};
